import type { IncomingMessage } from 'http';
import { breakpoints } from '../stylings';

const getHeaderValue = (header: string | string[] | undefined): string | undefined => {
  if (Array.isArray(header)) {
    return header[0];
  }
  return header;
};

export const getIsServerDesktop = (req: IncomingMessage | undefined) => {
  const cookies = req?.headers.cookie || '';
  const userDeviceCookie = cookies.split('; ').find((row) => row.startsWith('User-Device='));
  if (!userDeviceCookie) {
    return false;
  }
  const userDevice = userDeviceCookie.split('=')[1];
  const viewportWidthHeader = req?.headers['viewport-width'] || '';
  const isDesktopDevice = userDevice === 'desktop';
  const viewportWidth = getHeaderValue(viewportWidthHeader);
  if (!viewportWidth) {
    return false;
  }
  const isDesktopScreen = parseInt(viewportWidth, 10) >= breakpoints.desktop;

  return isDesktopDevice && isDesktopScreen;
};
